module.exports = __webpack_public_path__ + "img/dti.a97d1dee.png";